import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import {
  Button,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';

import { BackButton, PageTitle } from '../../../../../components/common';
import ButtonContainer from '../../../../../components/ButtonContainer';

import { StyledVerticalContent } from './ListWithRadioButton.styled';

function ListWithRadioButton(props) {
  const {
    name,
    backButtonLink,
    nextButtonLink,
    pageTitleId,
    pageTitleValues,
    listConfig,
    selected,
    setSelected,
  } = props;

  const history = useHistory();

  const questions = Array.isArray(listConfig) ? listConfig : [];

  return (
    <>
      <BackButton to={backButtonLink}>
        <Typography variant="h3">
          <FormattedMessage id="common.button.back" />
        </Typography>
      </BackButton>

      <PageTitle>
        <FormLabel id={`choose_${name}`}>
          <Typography variant="h1">
            <FormattedMessage id={pageTitleId} values={pageTitleValues} />
          </Typography>
        </FormLabel>
      </PageTitle>

      <RadioGroup
        aria-labelledby={`choose_${name}`}
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
        name={name}
      >
        <StyledVerticalContent>
          {questions.map((question) => {
            const { label, noTranslateLabel, value } = question || {};

            return (
              <Paper key={value}>
                <FormControlLabel
                  variant="alignCenter"
                  value={value}
                  control={<Radio />}
                  label={
                    noTranslateLabel ? (
                      <Typography variant="p" color="professional_blue">
                        {noTranslateLabel}
                      </Typography>
                    ) : (
                      <Typography variant="p" color="professional_blue">
                        <FormattedMessage id={label} />
                      </Typography>
                    )
                  }
                />
              </Paper>
            );
          })}
        </StyledVerticalContent>
      </RadioGroup>

      <ButtonContainer>
        <Button disabled={!selected} onClick={() => history.push(nextButtonLink)}>
          <Typography variant="buttons">
            <FormattedMessage id="common.button.next" />
          </Typography>
        </Button>
      </ButtonContainer>
    </>
  );
}

export default ListWithRadioButton;

ListWithRadioButton.defaultProps = {
  pageTitleValues: {},
};

ListWithRadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  backButtonLink: PropTypes.string,
  nextButtonLink: PropTypes.string,
  pageTitleId: PropTypes.string,
  pageTitleValues: PropTypes.instanceOf(Object),
  listConfig: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      noTranslateLabel: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  selected: PropTypes.string,
  setSelected: PropTypes.func,
};
